import { API_PREFIX } from "./api.constants";

export const COURSE_CONTENT_ENDPOINTS = {
  // Topics
  TOPICS: `${API_PREFIX}/course-content/topics`,
  TOPIC_DETAIL: (topicId: number | string) => `${API_PREFIX}/course-content/topics/${topicId}`,
  TOPICS_BY_COURSE: (courseId: number | string) => `${API_PREFIX}/course-content/course/${courseId}/topics`,

  // Activities
  ACTIVITIES: `${API_PREFIX}/course-content/activities`,
  STUDIO_LESSON_ACTIVITY: `${API_PREFIX}/course-content/activities/studio-lesson`,
  STUDIO_LINK_ACTIVITY: (activityId: number | string) => `${API_PREFIX}/course-content/activities/${activityId}/studio-link`,
  ACTIVITY_DETAIL: (activityId: number | string) => `${API_PREFIX}/course-content/activities/${activityId}`,
  ACTIVITIES_BY_TOPIC: (topicId: number | string) => `${API_PREFIX}/course-content/topics/${topicId}/activities`,
  DUPLICATE_ACTIVITY: (activityId: number | string) => `${API_PREFIX}/course-content/activities/${activityId}/duplicate`,

  // Recycle bin (soft-deleted activities)
  RECYCLE_BIN: (courseId: number | string) => `${API_PREFIX}/course-content/courses/${courseId}/recycle-bin`,
  RESTORE_ACTIVITY: (activityId: number | string) => `${API_PREFIX}/course-content/activities/${activityId}/restore`,
  PURGE_ACTIVITY: (activityId: number | string) => `${API_PREFIX}/course-content/activities/${activityId}/purge`,
  
  // Blocks
  BLOCK_DETAIL: (blockId: number | string) => `${API_PREFIX}/course-content/blocks/${blockId}`,
  BLOCKS_BY_ACTIVITY: (activityId: number | string) => `${API_PREFIX}/course-content/activities/${activityId}/blocks`,
  REORDER_BLOCKS: (activityId: number | string) => `${API_PREFIX}/course-content/blocks/reorder/activity/${activityId}`,
  
  // Progress
  MARK_BLOCK_COMPLETE: (blockId: number | string) => `${API_PREFIX}/course-content/blocks/${blockId}/complete`,
  USER_ACTIVITY_PROGRESS: (activityId: number | string) => `${API_PREFIX}/course-content/activities/${activityId}/user-progress`,

  // Content Library
  CONTENT_LIBRARY: `${API_PREFIX}/course-content/content-library`,

  // Learning Objects
  UPLOAD_SCORM: (activityBlockId: number | string) => `${API_PREFIX}/learning-objects/scorm/upload/${activityBlockId}`,
  LAUNCH_SCORM_PLAYER: (activityBlockId: number | string) => `${API_PREFIX}/learning-objects/scorm/player/${activityBlockId}`,
  GET_SCORM_LAUNCH_URL: (activityBlockId: number | string) => `${API_PREFIX}/learning-objects/scorm/launch-url/${activityBlockId}`,
  TRACK_SCORM: `${API_PREFIX}/learning-objects/scorm/track`,
  SCORM_ATTEMPTS: (activityBlockId: number | string) => `${API_PREFIX}/learning-objects/scorm/attempts/${activityBlockId}`,
  LAUNCH_LTI: (activityBlockId: number | string) => `${API_PREFIX}/learning-objects/lti/launch/${activityBlockId}`,
  RECEIVE_XAPI_STATEMENT: (xapiActivityId: number | string) => `${API_PREFIX}/learning-objects/xapi/statements/${xapiActivityId}`,
  GET_XAPI_STATEMENTS: (xapiActivityId: number | string) => `${API_PREFIX}/learning-objects/xapi/statements/${xapiActivityId}`,
};

export const QUESTIONNAIRE_ENDPOINTS = {
  QUESTIONNAIRES: `${API_PREFIX}/questionnaires`,
  QUESTIONNAIRES_BY_COURSE: (courseId: number | string) => `${API_PREFIX}/questionnaires/course/${courseId}`,
  QUESTIONNAIRE_DETAIL: (questionnaireId: number | string) => `${API_PREFIX}/questionnaires/${questionnaireId}`,
  SUBMIT_QUESTIONNAIRE: (questionnaireId: number | string) => `${API_PREFIX}/questionnaires/${questionnaireId}/submit`,
};

export const CERTIFICATE_ENDPOINTS = {
  TEMPLATES: `${API_PREFIX}/certificates/templates`,
  TEMPLATE_DETAIL: (templateId: number | string) => `${API_PREFIX}/certificates/templates/${templateId}`,
  ISSUE: `${API_PREFIX}/certificates/issue`,
  DOWNLOAD: (issueId: number | string) => `${API_PREFIX}/certificates/${issueId}/download`,
  VERIFY: (certId: string) => `${API_PREFIX}/certificates/verify/${certId}`,
  ACTIVITY_CONFIG: (activityId: number | string) => `${API_PREFIX}/certificates/activity/${activityId}`,
  ACTIVITY_ISSUE: (activityId: number | string) => `${API_PREFIX}/certificates/activity/${activityId}/issue`,
  ACTIVITY_LEARNERS: (activityId: number | string) => `${API_PREFIX}/certificates/activity/${activityId}/learners`,
  ACTIVITY_ISSUE_MANY: (activityId: number | string) => `${API_PREFIX}/certificates/activity/${activityId}/issue-many`,
  ACTIVITY_CLAIM: (activityId: number | string) => `${API_PREFIX}/certificates/activity/${activityId}/claim`,
  COURSE_ISSUED: (courseId: number | string) => `${API_PREFIX}/certificates/course/${courseId}/issued`,
  COURSE_ISSUED_ZIP: (courseId: number | string) => `${API_PREFIX}/certificates/course/${courseId}/issued/download-zip`,
  REGENERATE: (issueId: number | string) => `${API_PREFIX}/certificates/${issueId}/regenerate`,
  REVOKE: (issueId: number | string) => `${API_PREFIX}/certificates/${issueId}/revoke`,
  TEMPLATE_PREVIEW: `${API_PREFIX}/certificates/templates/preview`,
  FONTS: `${API_PREFIX}/certificates/fonts`,
  FONT: (fontId: number | string) => `${API_PREFIX}/certificates/fonts/${fontId}`,
  FONT_FILE: (fontId: number | string) => `${API_PREFIX}/certificates/fonts/${fontId}/file`,
  BUILTIN_FONT: (key: string) => `${API_PREFIX}/certificates/fonts/builtin/${key}`,
  BY_USER: (userId: number | string) => `${API_PREFIX}/certificates/users/${userId}`,
};

export const PUBLIC_ENDPOINTS = {
  VERIFY_CERTIFICATE: (certId: string) => `${API_PREFIX}/certificates/verify/${certId}`,
};